/** Filtrado en cliente de Mis Productos y Competidores.
 *
 * Extraído de PortfolioPage para testearlo. Estos filtros se aplican sobre el
 * array ya cargado (por eso la lista se trae TODAS las páginas, §61): un bug aquí
 * oculta filas al cliente sin avisar, que es justo lo que pasó con el techo de 200.
 */
/** CO-02 como atributo (catálogo 4.0): el nº de registro no tiene ninguna presentación
 *  comercializada desde `desde` (autorización o último cese); `meses` transcurridos. */
export type SinComercializar = { desde: string; base: "autorizacion" | "cese"; meses: number };

export type PortfolioItem = {
  therapeutic_area: string | null;
  laboratory: string | null;
  is_comercializado: boolean | null;
  sin_comercializar?: SinComercializar | null;
};

export type CompetitorItem = {
  therapeutic_area: string | null;
  company_name: string | null;
  competitor_type: string;
};

export type PortfolioFilters = { area: string; lab: string; status: string };
export type CompetitorFilters = { type: string; area: string; company: string };

/** Valores únicos de un campo, sin vacíos, ordenados alfabéticamente (para un <select>). */
export function uniqueSorted<T>(rows: T[], pick: (r: T) => string | null): string[] {
  return Array.from(new Set(rows.map(pick).filter(Boolean) as string[]))
    .sort((a, b) => a.localeCompare(b));
}

export function filterPortfolio<T extends PortfolioItem>(items: T[], f: PortfolioFilters): T[] {
  return items.filter(p =>
    (!f.area || p.therapeutic_area === f.area) &&
    (!f.lab || p.laboratory === f.lab) &&
    (!f.status || (f.status === "marketed" ? p.is_comercializado === true
      : f.status === "noPresentation" ? !!p.sin_comercializar          // registro sin ninguna comercializada
      : f.status === "co02" ? (p.sin_comercializar?.meses ?? 0) >= 30  // umbral de aviso de CO-02
      : p.is_comercializado === false))
  );
}

export function filterCompetitors<T extends CompetitorItem>(comps: T[], f: CompetitorFilters): T[] {
  return comps.filter(c =>
    (!f.type || c.competitor_type === f.type) &&
    (!f.area || c.therapeutic_area === f.area) &&
    (!f.company || c.company_name === f.company)
  );
}
